import React, { Component } from 'react'
import HtmlEditor from '../../Components/Commons/HtmlEditor'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import Select from 'react-select'
// import 'react-select/dist/react-select.css'
import moment from 'moment'
import FileItem from '../../Components/Intro/FileItem'
import { RoleStr } from '../../Components/Commons/Utils'

class PopForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            input: {
                title: '',
                content: '',
            },
            chargerGroup: [],
            chargerSelected: {
                value: '',
                label: '',
            },
            files: [],
            popForm: false,
            btnHide: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadProject()
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = (event) => {
        if (window.scrollY > 600) {
            this.setState({ btnHide: true })
        } else {
            this.setState({ btnHide: false })
        }
    }

    loadProject = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/projects/${cookies.get('project')}/users/`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const chargerGroup = this.state.chargerGroup

                res.data.forEach((user) => {
                    // const permittedGroups = ['ARCHITECT', 'CONSTRUCTOR', 'INTERIOR', 'SUPERVISOR', 'ADMIN']

                    // if (!user.group) return
                    // if (!permittedGroups.includes(user.group)) return
                    if (!user.company || user.company.name == null) return

                    if (user.status === 'ENABLED') {
                        let label = user.company.name + ' ' + user.name

                        if (user.project.isSiteManager) {
                            label += ' (현장소장)'
                        }

                        chargerGroup.push({
                            value: user._id,
                            label,
                        })
                    }
                })

                console.log(chargerGroup)
                // for (let i = 0; i < res.data; i += 1) {
                //     if (
                //         res.data[i].group !== '건축주' &&
                //         res.data.accounts[i].project.role !== '예비건축주'
                //     ) {
                //         let label = res.data.accounts[i].project.role + ' ' + res.data.accounts[i].name
                //         if (res.data.accounts[i].project.isManager) {
                //             label += ' (현장소장)'
                //         }

                //         chargerGroup.push({
                //             value: res.data.accounts[i]._id,
                //             label: label,
                //         })
                //     }
                // }

                this.setState({ chargerGroup })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addList = () => {
        if (this.state.chargerSelected.value === '') {
            alert('처리자를 지정해 주세요')
            return
        }
        if (this.state.input.title === '') {
            alert('제목을 입력해주세요')
            return
        } else if (this.state.input.content === '') {
            alert('내용을 입력해주세요')
            return
        }

        const files = this.state.files
        const finalFiles = files.map((file) => file._id)

        const { cookies } = this.props
        axios
            .post(
                `${BACKEND_HOST}/rfis/`,
                {
                    title: this.state.input.title,
                    content: this.state.input.content,
                    assignee_id: this.state.chargerSelected.value,
                    notifyUsers: [this.state.chargerSelected.value],
                    status: 'READY',
                    files: finalFiles,
                    project_id: cookies.get('project'),
                },
                {
                    headers: {
                        Authorization: `bearer ${Auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                console.log(res.data)
                this.props.addItem(res.data)
                this.setState({ popForm: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    handleModelChange = (model) => {
        const input = this.state.input
        input['content'] = model

        this.setState({
            input,
        })
    }

    openPopForm = () => {
        this.setState({ popForm: true })
    }

    closePopForm = () => {
        this.setState({ popForm: false })
    }

    handleSelect = (chargerSelected) => {
        this.setState({ chargerSelected })
    }

    arrowRenderer = () => {
        return (
            <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
                    <path
                        fill="none"
                        fillRule="evenodd"
                        stroke="#A2A7AE"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.2"
                        d="M10 2L6 6 2 2"
                    />
                </svg>
            </span>
        )
    }

    deleteFile = (item) => {
        let newFiles = ''
        newFiles = this.state.files.filter((data) => data !== item)

        this.setState({
            files: newFiles,
        })
    }

    fileUpload = (e) => {
        e.preventDefault()

        const file = document.querySelector('input[id=file1]').files[0]
        const data = new FormData()
        data.append('file', file)
        data.append('isEnabled', 'false')
        data.append('metadataType', 'RFI_FILE_V1')

        axios
            .post(`${BACKEND_HOST}/files/upload-files`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const newFiles = [...this.state.files, ...res.data]

                this.setState({
                    files: newFiles,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    FileList = (label) => {
        let files = ''
        files = this.state.files

        if (files.length === 0) {
            return (
                <label htmlFor={label} className="no_file_text">
                    파일을 첨부해주세요
                </label>
            )
        } else {
            const List = files.map((item) => {
                return <FileItem item={item} key={item.filename} deleteFile={this.deleteFile} />
            })
            return List
        }
    }

    render() {
        if (this.state.popForm) {
            return (
                <div className="pop_form_wrap">
                    <input
                        className="title_textarea"
                        placeholder="제목을 입력하세요!"
                        type="text"
                        name="title"
                        onChange={this.changeData}
                        value={this.state.input.title}
                    />
                    <div className="file_input_wrap">
                        <div className="file_input">
                            <div className="file_name">{this.FileList('file1')}</div>
                            <label htmlFor="file1" className="load_btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                    <path
                                        fill="none"
                                        fillRule="evenodd"
                                        stroke="#A2A7AE"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.3"
                                        d="M12.9 6.632l-5.484 5.643a3.512 3.512 0 0 1-5.067 0C.95 10.835.95 8.502 2.35 7.062L7.834 1.42a2.341 2.341 0 0 1 3.377 0c.933.96.933 2.515 0 3.475l-5.49 5.642a1.17 1.17 0 0 1-1.689 0 1.254 1.254 0 0 1 0-1.737L9.1 3.593"
                                    />
                                </svg>
                                <p>파일 첨부</p>
                            </label>
                            <input id="file1" type="file" onChange={(e) => this.fileUpload(e)} />
                        </div>
                    </div>
                    <HtmlEditor content={this.state.input.content} handleModelChange={this.handleModelChange} />
                    <ul className="btn_wrap pc_v">
                        <li className="gray_btn_s" onClick={() => this.closePopForm()}>
                            취소
                        </li>
                        <li className="green_btn_s" onClick={this.addList}>
                            등록
                        </li>
                    </ul>
                    {this.state.btnHide === false && (
                        <ul className="btn_wrap mobile_v">
                            <li className="cancel_btn" onClick={() => this.closePopForm()}>
                                취소
                            </li>
                            <li className="ok_btn" onClick={this.addList}>
                                등록
                            </li>
                        </ul>
                    )}

                    <div className="select_wrap">
                        <label>처리자</label>
                        <Select
                            name="manager"
                            value={this.state.chargerSelected}
                            onChange={this.handleSelect}
                            placeholder="처리자 선택"
                            arrowRenderer={this.arrowRenderer}
                            clearable={false}
                            options={this.state.chargerGroup}
                        />
                    </div>
                </div>
            )
        }
        return (
            <div className="pop_btn" onClick={() => this.openPopForm()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <g fill="none" fillRule="evenodd">
                        <path
                            stroke="#A2A7AE"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1.3"
                            d="M10.743 1.007l1.03 1.031a1 1 0 0 1 0 1.414l-6.829 6.843H2.5V7.85l6.828-6.843a1 1 0 0 1 1.415 0z"
                        />
                        <path fill="#A2A7AE" stroke="#A2A7AE" strokeLinecap="square" d="M8.5 2.5l2 2" />
                        <rect width="13" height="1.2" x=".5" y="12.759" fill="#A2A7AE" fillRule="nonzero" rx=".6" />
                    </g>
                </svg>
                요청사항을 적어주세요
            </div>
        )
    }
}

export default withCookies(PopForm)



// WEBPACK FOOTER //
// ./Src/Components/Demand/PopForm.js